import { html } from 'lit';
import { fixture, expect } from '@open-wc/testing';
import { VaaEmbed } from '../src/VaaEmbed.js';
import '../src/vaa-embed.js';

describe('VaaEmbed', () => {
  it('passes the a11y audit', async () => {
    const el = await fixture<VaaEmbed>(html`<vaa-embed></vaa-embed>`);

    await expect(el).shadowDom.to.be.accessible();
  });
});
